import { render } from "./hyqz.vue?vue&type=template&id=4470ad2d&scoped=true&ts=true"
import script from "./hyqz.vue?vue&type=script&lang=ts"
export * from "./hyqz.vue?vue&type=script&lang=ts"

import "./hyqz.vue?vue&type=style&index=0&id=4470ad2d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4470ad2d"]])

export default __exports__